import { Text, View } from '@react-pdf/renderer';

import { IInvoicePdf } from '../../types/IInvoicePdf';
import { InvoiceTemplate } from '../InvoiceTemplateForm';

import styles from './Styles';

export const Client = ({
  invoice,
  template,
}: {
  invoice: IInvoicePdf;
  template?: InvoiceTemplate;
}) => {
  const showClientName = template?.clientName ?? true;
  const showClientAddress = template?.clientAddress ?? true;
  return (
    <View style={styles.invoice_body}>
      <View style={styles.half_section}>
        {(showClientName || showClientAddress) && (
          <>
            <Text style={styles.subTitle}>Billed To:</Text>
            {showClientName && (
              <Text style={styles.subTitle_plain}>{invoice.client.legalName}</Text>
            )}
            {showClientAddress && <Text style={styles.text}>{invoice.client.address}</Text>}
          </>
        )}
      </View>
    </View>
  );
};
